// Copyright (c) 2017 Deere & Company

import * as fetchService from '../../../shared/services/fetch';
import {handleError} from '../../../shared/services/error-handlers';

const basePath = '/api';

const builtParams = params => params ?
    `?${Object.keys(params)
        .filter(param => params[param])
        .map(param => `${param}=${params[param]}`)
        .join('&')}` :
    '';

export const getClaimSummary = async params => {

    const endPoint = `${basePath}/claim-summary${builtParams(params)}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

};

export const getReimbursementSummary = async params => {

    const endPoint = `${basePath}/reimbursement-summary${builtParams(params)}`;

    try {

        const response = await fetchService.fetch(endPoint);

        return response.json();

    } catch (response) {

        return handleError(response);

    }

};



// WEBPACK FOOTER //
// ./src/reimbursement-summary/shared/repositories/index.js